wbApp.directive('wbActivityWeekEditor', [
    function () {

        return {
            restrict: 'A',
            priority: 1,
            replace: true,
            scope: {
                ngModel: '=',
                inLineNote: '=',
                scheduleOnly: '=',
                foodSupport: '=',
                singlePeriod: '='
            },
            templateUrl: 'activities/directives/activity-week-editor.html',
            link: function (scope, elem, attrs) {

                scope.selectedDay = {};

                scope.onNoteClick = function (day) {
                    scope.selectedDay = day;
                }
            }
        }
    }]);